class BlogArticle extends HTMLElement {
  constructor() {
    super();
    this.dialogElement = document.getElementById('ArticleLightboxModal');
    this.lightboxContent = this.dialogElement.querySelector('.article-lightbox__content-info');

    const images = this.querySelectorAll('.article-template__content img');
    images.forEach((image) => {
      image.addEventListener('click', (event) => {
        if (event.target.closest('.product-callout')) {
          return;
        }
        const image = event.target.cloneNode(true);
        this.lightboxContent.replaceChildren(image);
        this.dialogElement.show();
      });
    });
  }
}

customElements.define('blog-article', BlogArticle);
